import { render, staticRenderFns } from "./EmployeeCoursesAdmin.vue?vue&type=template&id=ff985748&scoped=true"
import script from "./EmployeeCoursesAdmin.vue?vue&type=script&lang=js"
export * from "./EmployeeCoursesAdmin.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCoursesAdmin.vue?vue&type=style&index=0&id=ff985748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff985748",
  null
  
)

export default component.exports